import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

// Get Landlord Dashboard Stats
export const GetLandlordDashboardStats = createAsyncThunk(
  "dashboard/getLandlordStats",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("ots_token");
      const response = await axios.get(
        `${BASE_URL}/landlord-dashboard-stats/${userId}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get Tenant Dashboard Stats
export const GetTenantDashboardStats = createAsyncThunk(
  "dashboard/getTenantStats",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("ots_token");
      const response = await axios.get(
        `${BASE_URL}/tenant-dashboard-stats/${userId}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: token ? `Bearer ${token}` : "",
          },
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const DashboardStats = createSlice({
  name: "dashboardStats",
  initialState: {
    loading: false,
    landlordStats: null,
    tenantStats: null,
    error: "",
  },
  reducers: {
    resetDashboardStats: (state) => {
      state.loading = false;
      state.landlordStats = null;
      state.tenantStats = null;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Landlord Stats
      .addCase(GetLandlordDashboardStats.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(GetLandlordDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.landlordStats = action.payload?.data?.data;
        state.error = "";
      })
      .addCase(GetLandlordDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      // Tenant Stats
      .addCase(GetTenantDashboardStats.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(GetTenantDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.tenantStats = action.payload?.data?.data;
        state.error = "";
      })
      .addCase(GetTenantDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetDashboardStats } = DashboardStats.actions;
export default DashboardStats.reducer;
